import { useState, useEffect } from 'react';
import Sparkline from './Sparkline';
import numberWithCommas from '../../utils/numberWithCommas';
import IconTooltip from '../IconTooltip';
import InfoIcon from '../Scaffolding/InfoIcon';
import WaitingIndicator from '../../../../general-ui/waiting-indicator/waiting-indicator';
interface ScorecardProps {
	index: number;
	showTL: boolean;
	showMM: boolean;
	data: any;
	title?: string
	interval?: string;
	loading?: boolean;
	error?: string | null;
	tooltipText?: string;
}

function Scorecard({ index, showTL, showMM, data, title, interval = '', loading, error, tooltipText }: ScorecardProps): JSX.Element {
	const [showTrendline, setShowTrendline] = useState(false);
	const [showMinMax, setShowMinMax] = useState(false);
	const [showTooltip, setShowTooltip] = useState(false);
	const [pageX, setPageX] = useState(0);
	const [pageY, setPageY] = useState(0);
	useEffect(() => {
		setShowTrendline(showTL);
		setShowMinMax(showMM);
	}, [showTL, showMM]);


	let sparklineTrendMetricValue = 0;
	if (data.sparkline) {
		sparklineTrendMetricValue = data.sparkline[(data.sparkline).length - 1] - (data.sparkline[(data.sparkline).length - 2] || 0);
	}
	const className = 'scorecard ' + (showTrendline && showMinMax ? "scorecard-large" : (showTrendline ? "scorecard-medium" : "scorecard-small"));

	const hideData = loading || data.value == null || error;

	return (
		<div className={className} id={`scorecard-${index}`}>
			<div className="scorecard-title">
				<p className="scorecard-title-text">{title}</p>
				{tooltipText && <InfoIcon setShowTooltip={setShowTooltip} setPageX={setPageX} setPageY={setPageY} />}
			</div>
			<div className="scorecard-body">
				{hideData ?
					<div className="scorecard-loading">
						{loading && <WaitingIndicator />}
						{error && <div>{error}</div>}
					</div> :
					<div className="scorecard-metric">
						<p className="scorecard-number">{numberWithCommas(data.value)}</p>

						{showTrendline && data.sparkline?.length ?
							<div className="sparkline-group">
								<Sparkline index={index} data={data.sparkline} />
								<div className="sparkline-trend-metric">
									{sparklineTrendMetricValue >= 0 ?
										<i className="sparkline-trend-metric-arrow text-icon up">&#x2197;</i> :
										<i className="sparkline-trend-metric-arrow text-icon down">&#x2198;</i>}

									<p className="sparkline-trend-metric-value">{numberWithCommas(sparklineTrendMetricValue)}</p>
									<p className="sparkline-trend-metric-period">{interval ? `Last ${interval}` : ''}</p>
								</div>
							</div>
							: <></>}
					</div>
				}

				{showTrendline && showMinMax && !hideData ?
					<div className="scorecard-min-max">
						<p className="scorecard-min-max-label">MIN AUDIENCE</p>
						<p className="scorecard-min-max-value">{numberWithCommas(data.min)}</p>

						<p className="scorecard-min-max-label">Max AUDIENCE</p>
						<p className="scorecard-min-max-value">{numberWithCommas(data.max)}</p>


					</div> :
					<></>
				}

				{tooltipText && <IconTooltip
					id={`scorecard-${index}`}
					showTooltip={showTooltip}
					pageX={pageX}
					pageY={pageY}
					tooltipText={tooltipText} />}
			</div>
		</div>
	);
}

export default Scorecard;
